import React from "react"
import { PageLayout } from "#/features/global-ui/page-layout"
import { PageHeader } from "#/features/global-ui/page-header"
import { Title } from "#/services/page-title/Title"
import { useDevToolsUserSnapshot } from "#/utils/devTools/useDevToolsUserSnapshot"
import { LoadingInner } from "../../Loading"

// The dev-tools package is code-split, so its chunk only loads once this route mounts.
const DevToolsRouter = React.lazy(() => import("@internal/dev-tools").then((m) => ({ default: m.DevToolsRouter })))

// Wraps the dev tools in the standard page frame. This exists as its own component so
// useDevToolsUserSnapshot runs ONLY when the route matches — called from App it would fire its
// member-program queries on every authenticated page, including the routes outside NavLayout
// that never issue them, and including production where the route isn't even registered.
export function DevToolsRoute(): JSX.Element {
  const user = useDevToolsUserSnapshot()

  return (
    <>
      {/* Overrides the default <Title>, which falls back to "Page not found" for any path
          outside its map. Passed as a prop rather than added to that map so it stays out of
          the translation pipeline. */}
      {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx -- internal tooling is untranslated */}
      <Title title="Dev tools" />
      <PageLayout header={<PageHeader pageTitle="Dev tools" />}>
        <React.Suspense fallback={<LoadingInner />}>
          <DevToolsRouter user={user} />
        </React.Suspense>
      </PageLayout>
    </>
  )
}
